import { appConfig } from 'config/environment/appConfig'
import { AddLayerObject, MapLibreEvent } from 'maplibre-gl'
import { useTranslation } from 'react-i18next'
import Map from 'react-map-gl/maplibre'
import { VectorSourceSpecification } from '@maplibre/maplibre-gl-style-spec'

import { Flex } from 'components/uiKit'
import { isGeDomain } from 'utils/helpers/domains/getDomain'

import rawLayers from './layers.json'

import pin from 'assets/img/map/pin-map-select.svg'
import 'maplibre-gl/dist/maplibre-gl.css'
import s from './OrdersMap.module.scss'

// координаты центра Москвы
const redSquare = {
  lon: '37.618423',
  lat: '55.751244',
}

// координаты центра Тбилиси
const tbilisi = {
  lon: '44.796448',
  lat: '41.719861',
}

type OrdersMapProps = {
  height?: number
  centerLongitude?: string
  centerLatitude?: string
}

export function OrdersMap({
  height,
  centerLongitude = isGeDomain() ? tbilisi.lon : redSquare.lon,
  centerLatitude = isGeDomain() ? tbilisi.lat : redSquare.lat,
}: OrdersMapProps) {
  const viewState = {
    longitude: parseFloat(centerLongitude),
    latitude: parseFloat(centerLatitude),
    zoom: 15,
  }

  const { i18n } = useTranslation()

  const onLoadHandler = (e: MapLibreEvent) => {
    const map = e.target

    Object.entries(rawLayers.sources).map(([key, value]) => {
      map.addSource(key, {
        type: value.type,
        tiles: [`${appConfig.TILE_SERVER_URL}/${value.layers}/{z}/{x}/{y}`],
      } as VectorSourceSpecification)
    })

    rawLayers.layers.map(async (layer) => {
      if (layer.layout !== undefined && layer.layout['icon-image']) {
        const response = await map.loadImage(`/img/map/${layer.layout['icon-image']}.png`)
        map.addImage(layer.layout['icon-image'], response.data)
      }

      map.addLayer(layer as AddLayerObject)
    })
  }

  return (
    <Flex className={s.mapContainer} style={{ height: height ?? 'auto' }}>
      <div className={s.pin}>
        <img src={pin} alt="📍" />
      </div>

      <Map
        {...viewState}
        style={{ width: '100%', height: '100%' }}
        mapStyle={i18n.language === 'ru' ? '/basemaps/basemapRu.json' : '/basemaps/basemapEn.json'}
        attributionControl={false}
        onLoad={onLoadHandler}
      />
    </Flex>
  )
}
